import axios from 'axios';
import { STOREFRONT_API_KEY, STOREFRONT_API_URL } from '../constants';
import { Subscription, SubscriptionLine } from '../types/constant/SubscriptionType';

/**
 * 商品情報に必要情報を追加
 * @param variants
 * @return variants
 */
export async function addRequiredInfo(subscriptionLines: SubscriptionLine[]) {
  const variants = subscriptionLines.map(async (variant) => {
    // variantに情報を追加
    try {
      const result = await axios.post(
        STOREFRONT_API_URL!,
        {
          query: `
            query {
              product(id: "${variant.productId}") {
                displayUnit: metafield(namespace: "my_account", key: "display_unit") {
                  value
                },
                images(first: 100) {
                  nodes {
                    url
                  }
                },
                handle
              }
            }
          `,
        },
        {
          headers: {
            'X-Shopify-Storefront-Access-Token': STOREFRONT_API_KEY,
          },
        }
      );

      return {
        ...variant,
        // メタフィールド情報
        displayUnit: result.data.data.product?.displayUnit?.value ?? '',
        // 画像情報上書き（アプリ仕様で既存契約が存在する定期商品の商品画像を差し替えると画像がリンク切れするため）
        variantImage: result.data.data.product?.images.nodes[0].url ?? '',
      };
    } catch (error) {
      console.error(error);
      return {
        ...variant,
      };
    }
  });

  const processedVariants = await Promise.all(variants);

  return processedVariants;
}

/**
 * 定期一覧の商品情報を上書き
 * @param subscriptions
 * @return subscriptions
 */
export async function editSubscriptions(subscriptions: Subscription[]) {
  // ACTIVEとPAUSEDの契約に紐づくproductIdを取得
  const productIds = subscriptions
    .filter((subscription) => subscription.status === 'ACTIVE' || subscription.status === 'PAUSED')
    .flatMap((subscription) => subscription.subscriptionLines.map((product) => product.productId));

  // 重複を排除
  const uniqueProductIds = productIds.filter(
    (productId, index) => productIds.indexOf(productId) === index
  );

  // 商品情報取得
  const productInfo = await getProductInfo(uniqueProductIds);

  // 商品情報を上書き
  const productIdMap = {};
  productInfo.forEach((info) => {
    productIdMap[info.productId] = info.variantImage;
  });
  subscriptions.forEach((subscription) => {
    subscription.subscriptionLines.forEach((product) => {
      const imageUrl = productIdMap[product.productId] ?? '';
      product.variantImage = imageUrl;
    });
  });
  return subscriptions;
}

/**
 * productIdから商品情報取得
 * @param arrayProductId
 * @return productInfo
 */
async function getProductInfo(arrayProductId: string[]) {
  const result = await axios.post(
    STOREFRONT_API_URL!,
    {
      query: `
        query {
          nodes(
            ids: ${JSON.stringify(arrayProductId)}
          ) {
            ... on Product {
              id
              images(first: 1) {
                nodes {
                  url
                }
              }
            }
          }
        }
      `,
    },
    {
      headers: {
        'X-Shopify-Storefront-Access-Token': STOREFRONT_API_KEY,
      },
    }
  );

  const productInfo = result.data.data.nodes
    .filter((product) => product !== null)
    .map((product) => {
      return {
        productId: product.id ?? '',
        variantImage: product.images.nodes[0].url ?? '',
      };
    });

  return productInfo;
}
